module.exports = __webpack_public_path__ + "static/media/check-success.c726c813.png";